<template>
  <el-dialog
    v-model="visible"
    width="600px"
    @close="handleClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <template #header>
      <span class="text-[#1D2129] font-semibold">开通协议</span>
      <img
        src="//filecdn.hgj.com/storybrooke-manifest/website/agree-header.png"
        alt=""
        width="244"
        class="absolute -top-35px -right-2px"
      />
    </template>
    <p class="text-#111111 text-16px !mb-12px">请阅读以下协议：</p>
    <div v-html="content" class="max-h-300px"></div>
    <template #footer>
      <span>
        <el-button color="#F2F3F5" @click="handleClose"> 取消 </el-button>
        <el-button type="primary" @click="handleConfirm"> 同意 </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script lang="ts" setup>
import { updateAgreeState } from '@/api/user'
import content from '@/plugins/applyContent'
const visible = ref(true)

const emits = defineEmits(['resolve', 'reject'])

const handleClose = () => {
  emits('reject')
}
const handleConfirm = async () => {
  const { code } = await updateAgreeState()
  if (code === 200) {
    emits('resolve', true)
  }
}
</script>
<style scoped lang="scss"></style>
